// extracted by mini-css-extract-plugin
module.exports = {"root":"WriterForm_root__3dvwD","paper":"WriterForm_paper__2N4fr","title":"WriterForm_title__3PP3v","content":"WriterForm_content__vsIPC","actions":"WriterForm_actions__3UsDn"};